/**
 * Whether the sidebar's chart-search box applies to the page on screen.
 *
 * Only the surfaces that carry `data-chart-search-title` anchors: the maneuver report's SCATTER
 * and TIME SERIES views, and the PERFORMANCE report (every scope — dataset, day fleet, live, source
 * and fleet history — shares the one menu identity). Kept out of Sidebar.tsx so it is unit-testable
 * without pulling that component's import graph into a test.
 */

/** Same fold as Sidebar.tsx's normalizeSidebarPageName. */
const normalizeMenu = (s: string | undefined | null): string =>
  (s ?? "").toString().replace(/\s+/g, "").replace(/_/g, "").toUpperCase();

export const isPerformanceReportMenu = (menu: string | undefined | null): boolean => {
  const n = normalizeMenu(menu);
  return n === "PERFORMANCE" || n === "FLEETPERFORMANCE" || n === "FLEETPERFORMANCEHISTORY";
};

/** Canonical maneuver view for a raw view/submenu string; BOXES is the legacy grouped SCATTER label. */
export function normalizeManeuverView(raw: string | undefined | null): string {
  const n = (raw ?? "").trim().toUpperCase().replace(/\s+/g, " ");
  if (n === "BOXES") {return "SCATTER";}
  if (n === "TIMESERIES") {return "TIME SERIES";}
  return n;
}

/**
 * @param activeManeuverView the mounted maneuver page's real view (activeManeuverViewStore); it
 *   wins over `page`, which goes stale when the page's own View dropdown is used.
 */
export function shouldShowChartSearch(
  menu: string | undefined | null,
  page: string | undefined | null,
  activeManeuverView?: string | null
): boolean {
  if (normalizeMenu(menu) === "MANEUVERS") {
    const view = normalizeManeuverView((activeManeuverView ?? "").trim() || page);
    return view === "SCATTER" || view === "TIME SERIES";
  }
  return isPerformanceReportMenu(menu);
}
